import React from 'react';

import { Button } from './Button.styles';

/* eslint-disable no-unused-vars */
const ButtonComponent = ({
  text,
  disabled,
  disabledText,
  dark = false,
  language,
  color,
  hoverColor,
  ...rest
}) => (
  <Button
    {...rest}
    disabled={disabled}
    dark={!!dark}
    color={color}
    hoverColor={hoverColor}
  >
    {disabled ? disabledText : text}
  </Button>
);

export default ButtonComponent;
